import { BaseError, mergeLogOptions } from '../errors';
import { LogErrorOptions } from '../log-error';

export class RetryWithTimeoutError extends BaseError {
    static enhance(error: RetryWithTimeoutError, loggerFields: LogErrorOptions) {
        return new RetryWithTimeoutError(mergeLogOptions(error.loggerFields, loggerFields));
    }

    constructor(loggerFields?: LogErrorOptions) {
        super('Timed out', { method: 'retryWithTimeout', ...loggerFields });

        Object.setPrototypeOf(this, RetryWithTimeoutError.prototype);
    }
}

export class UnexpectedError extends BaseError {
    constructor(loggerFields?: LogErrorOptions) {
        super('Unexpected error', { method: 'retryWithTimeout', ...loggerFields });

        Object.setPrototypeOf(this, UnexpectedError.prototype);
    }
}
